import { useMemo } from 'react';
import { videoExtensions, PLACEHOLDER_IMAGE } from 'config/Constants';

const VideoImagePreviewer = ({ url, autoPlay = true, muted = true, loop = true }) => {
  const isVideo = useMemo(() => {
    try {
      const pathname = new URL(url)?.pathname?.toLowerCase();
      return videoExtensions?.some((ext) => pathname?.endsWith(ext));
    } catch {
      return false;
    }
  }, [url]);

  if (isVideo && url) {
    return (
      <video src={url} autoPlay={autoPlay} loop={loop} muted={muted} className='w-full h-full'>
        Your browser does not support the video tag.
      </video>
    );
  }

  return <img src={url || PLACEHOLDER_IMAGE} alt='media' className='w-full h-full' />;
};

export default VideoImagePreviewer;
